'use strict';

const 	ServiceFactory	= require('factories/Service')
		, NotificationProvider	= new(require('providers/Notification'))()
		;

module.exports = ServiceFactory.create({
	displayName : 'Notification',
	methods : {
		getNotificationUnreadCount : function(accountId, sessionId){
			return NotificationProvider.getNotificationUnreadCount(accountId, sessionId).then((result)=>{
				this.dispatch({
					type : 'NOTIFICATION_UNREAD_COUNT_SUCCESS',
					payload : result
				})
				return result;
			})
		},
		getAppBadgeNumbers : function(sessionId){
			return NotificationProvider.getAppBadgeNumbers(sessionId).then((result)=>{
				this.dispatch({
					type : 'NOTIFICATION_UNREAD_COUNT_VENDOR_SUCCESS',
					payload : result
				})
				return result;
			})
		}

	}
})



// WEBPACK FOOTER //
// providers/services/Notification.js